import React, {useEffect, useRef, useState} from 'react'
import {ModeleClientDemande, modeleClientDemandeInitValues} from '../../../../components/Models'
import {KTSVG} from '../../../../_metronic/helpers'
import {TextInput} from '../../../../components/inputs/TextInput'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useNavigate} from 'react-router-dom'
import {
  getCatdata,
  getInfoVehicle,
  getOneVehicleHorsTypeByMarqueModele,
  getSiteVehicule,
  postGenreByCode,
} from '../../../../components/requests'
import {Tooltip} from 'react-tooltip'
import Select from 'react-select'
import moment from 'moment'

const clientDemandeSchema = Yup.object().shape({
  commentaire: Yup.string().notRequired(),
})

const ResearchVehicleModal = (props) => {
  const {
    clientId,
    redirectToClientDemande,
    handleSubmit,
    defaultValueContact,
    isFromAddClientContact,
    radioValue,
    isFromClient,
    demandeId,
    contactedBy,
    choicedDemandeSource,
    setChoicedDemandeSource,
    sourceLoader,
    transformedSource,
    contentCommunication,
    labelSearch,
  } = props
  const navigate = useNavigate()
  const [loadingCatdata, setLoadingCatdata] = useState<boolean>(false)
  const [loadingHtData, setLoadingHtData] = useState<boolean>(false)
  const [dataVehicle, setDataVehicle] = useState<any>([])
  const [message, setMessage] = useState<string>('')
  const [disableMarqueModeleInput, setDisableMarqueModeleInput] = useState<boolean>(true)
  const [isImmatNotFound, setIsImmatNotFound] = useState<boolean>(false)
  const btnCloseRef = useRef<any>(null)
  const modalRef = useRef<HTMLDivElement | null>(null)
  const [showBtnHT, setShowBtnHT] = useState<boolean>(false)
  const [immatRecherchee, setImmatRecherchee] = useState<string | null>(null)
  const [searchTerm, setSearchTerm] = useState({marque: '', modele: ''})

  const [showDemandeSource, setShowDemandeSource] = useState<boolean>(false)
  const [showDataImmat, setShowDataImmat] = useState<boolean>(false)
  const [displayInfoVehicule, setDisplayInfoVehicule] = useState<boolean>(false)
  const [dataImmat, setDataImmat] = useState<any>('')
  const [loadingDataImmat, setLoadingDataImmat] = useState<boolean>(false)
  const [dynamicHeight, setDynamicHeight] = useState<number>(0)
  const [genreImmat, setGenreImmat] = useState<any>('')
  const [loading, setLoading] = useState(false)

  const formik = useFormik<ModeleClientDemande>({
    initialValues: modeleClientDemandeInitValues,
    validationSchema: clientDemandeSchema,
    onSubmit: (values) => {},
  })

  // Vérifier les infos (par immatriculation ou par marque et modèle)
  const checkInfo = async (immatriculation) => {
    setMessage('')
    if (formik.values.immatriculation && disableMarqueModeleInput) {
      setLoadingCatdata(true)
      const check = await verifyCatdata(immatriculation)
      // si l'immat n'est pas trouvée, stocker cette dernière et afficher l'entête pour le choix
      if (check === 'not_found' || check === 'error') {
        setIsImmatNotFound(true)
        setImmatRecherchee(immatriculation)
        setLoadingCatdata(false)
      } else {
        if (btnCloseRef.current) {
          btnCloseRef.current.click()
        }

        setIsImmatNotFound(false)
        handleNavigate(immatriculation, null)
      }
    } else if (formik.values.marque || formik.values.modele) {
      setLoadingCatdata(true)
      getInfoVehicle(formik.values.marque?.trim() ?? '', formik.values.modele?.trim() ?? '').then(
        (response) => {
          if (response && response.status == 200 && response.data) {
            // setDataVehicle({...response.data, isHorsType: false})
            setDataVehicle(response.data)
            if (response.data.length == 0) setMessage('Aucun résultat')
            setLoadingCatdata(false)
            // ne pas afficher le bouton HorsType qu'après la recherche par marque et modèle
            setShowBtnHT(true)
            setShowDemandeSource(true)
          }
        }
      )
    }
  }

  // Cacher le bouton hors type lors d'un changement marque ou modèle
  useEffect(() => {
    setShowBtnHT(false)
  }, [formik?.values?.marque, formik?.values?.modele])

  // Redirection vers la création de demande
  const handleNavigate = async (immat, dataVehicle) => {
    const pathname = window.location.pathname
    const regex = /^\/demandes\/create\/(\d+)$/
    const regexEdit = /^\/demandes\/(\d+)\/edit\/(\d+)$/
    const inDemandeCreate = regex.test(pathname)
    const inDemandeEdit = regexEdit.test(pathname)

    setLoadingHtData(true)
    let formatedDataVehicle = null
    if (dataVehicle?.isHorsType !== undefined && dataVehicle?.isHorsType === true) {
      await getOneVehicleHorsTypeByMarqueModele(dataVehicle?.marque?.nom, dataVehicle?.nom).then(
        (response) => {
          if (response?.status === 200 && response?.data) {
            formatedDataVehicle = {
              ...dataVehicle,
              codeMoteur: response?.data?.codeMoteur,
              cylindre: response?.data?.cylindre,
              debutPhase: response?.data?.debutPhase,
              finPhase: response?.data?.finPhase,
              groupe: response?.data?.groupe,
              phase: response?.data?.phase,
              vin: response?.data?.vin,
              puissance: response?.data?.puissance,
              type: {libelle: response?.data?.type, groupe: {libelle: response?.data?.groupe}},
              // VHT pas de site
              site: null,
            }
            dataVehicle = formatedDataVehicle
          }
        }
      )
      if (btnCloseRef.current) btnCloseRef.current.click()
    }
    setLoadingHtData(false)
    if (btnCloseRef?.current) {
      btnCloseRef?.current?.click()
    }

    if (!inDemandeCreate && !inDemandeEdit) {
      navigate(`/demandes/create/${clientId}`, {
        state: {
          immat: immat ? [immat] : [],
          dataVehicle: dataVehicle?.id ? {[dataVehicle.id]: dataVehicle} : {},
          redirectToClientDemande: redirectToClientDemande,
          allowAddCentre: true,
          defaultValueContact: defaultValueContact,
          radioValue: radioValue,
          isFromClient: isFromClient,
          clientId: clientId,
          choicedDemandeSource: choicedDemandeSource,
          contactedBy: contactedBy,
          contentCommunication: contentCommunication,
          labelSearch: labelSearch,
        },
      })
    } else {
      handleSubmit(immat, dataVehicle, choicedDemandeSource)
    }
    setLoadingCatdata(false)
    await formik.setFieldValue('immatriculation', '')
    await formik.setFieldValue('marque', '')
    await formik.setFieldValue('modele', '')
    setDataVehicle([])
    setShowDemandeSource(false)
  }

  const verifyCatdata = async (immat) => {
    if (!dataImmat) {
      setLoadingDataImmat(true)
    }
    const immatriculation = immat ?? formik.values?.immatriculation
    if (immatriculation) {
      try {
        const immatriculationRequest = await getCatdata(immatriculation)

        if (immatriculationRequest?.status === 200 && immatriculationRequest?.data) {
          setDataImmat(immatriculationRequest?.data)
          if (
            immatriculationRequest.data.sMessageErreur === 'No data for this vehicle' ||
            immatriculationRequest.data.sMessageErreur === null
          ) {
            setLoadingCatdata(false)
            return 'not_found'
          }
          setLoadingDataImmat(false)
          setDataVehicle([])
          getGenreByCode(immatriculationRequest?.data?.sgenre)
        } else {
          setDataImmat('')
          return 'error'
        }
      } catch (ex: any) {
        if (ex?.response?.status === 500) {
          setLoadingCatdata(false)
          setLoadingDataImmat(false)
        }
        return 'error'
      } finally {
        setLoadingCatdata(false)
        setLoadingDataImmat(false)
      }
    }
  }

  const continueAction = () => {
    setIsImmatNotFound(false)
    setDisableMarqueModeleInput(false)
  }

  // Réinitialiser le comportement des champs dans le modal lors de son apparition
  useEffect(() => {
    const modal = modalRef.current
    if (modal) {
      modal.addEventListener('shown.bs.modal', () => {
        setMessage('')
        setDisableMarqueModeleInput(true)
        setImmatRecherchee(null)
      })
    }

    return () => {
      if (modal) {
        modal.removeEventListener('shown.bs.modal', () => {})
      }
    }
  }, [])

  useEffect(() => {
    setSearchTerm({
      marque: formik.values.marque?.trim() || '',
      modele: formik.values.modele?.trim() || '',
    })
  }, [formik.values.marque, formik.values.modele])

  // Debounce de 500ms sur la saisie de la marque ou modèle
  useEffect(() => {
    if (!searchTerm.marque && !searchTerm.modele) return

    const timer = setTimeout(() => {
      setDataVehicle([])
      setLoadingCatdata(true)
      getInfoVehicle(formik.values.marque?.trim() ?? '', formik.values.modele?.trim() ?? '').then(
        (response) => {
          if (response && response.status == 200 && response.data) {
            setDataVehicle(response.data)
            setDataImmat('')
            setShowDataImmat(false)
            if (response.data.length == 0) {
              setMessage('Aucun résultat')
            }
            if (response?.data.length > 2) {
              setDynamicHeight(400)
            }
            setLoadingCatdata(false)
            // ne pas afficher le bouton HorsType qu'après la recherche par marque et modèle
            setShowBtnHT(true)
            setShowDemandeSource(true)
          }
        }
      )
    }, 500)

    return () => clearTimeout(timer)
  }, [searchTerm])

  // debut gestion affichage du bouton valider et rechercher
  const hasMarqueOrModele = formik.values.marque?.trim() || formik.values.modele?.trim()

  const isValider = Boolean(formik.values.immatriculation && showDemandeSource)

  const isDisabledBase =
    (!formik.values.immatriculation && !hasMarqueOrModele && disableMarqueModeleInput) ||
    (!disableMarqueModeleInput && !hasMarqueOrModele)

  const isDisabled =
    isDisabledBase || (isFromClient ? !choicedDemandeSource : demandeId && !choicedDemandeSource) // seulement pour "Valider"

  const handleClick = () => {
    if (formik.values.immatriculation && !showDemandeSource) {
      setShowDemandeSource(true)
      setShowDataImmat(true)
      verifyCatdata(formik.values.immatriculation)
    } else {
      checkInfo(formik.values.immatriculation)
    }
  }

  const buttonLabel = isValider ? 'Valider' : 'Rechercher'
  const loadingLabel = isValider ? 'Valider...' : 'Recherche...'
  // fin gestion affichage du bouton valider et rechercher

  useEffect(() => {
    if (formik.values.immatriculation) {
      setDataVehicle('')
    }
    if (formik.values.marque || formik.values.modele) {
      setDataImmat('')
    }
    if (!formik.values.marque && !formik.values.modele) {
      setDataImmat('')
      setDataVehicle('')
      setShowDemandeSource(false)
      setShowDataImmat(false)
    }
  }, [formik.values.immatriculation, formik.values.marque, formik.values.modele])

  // Récupération du centre de l'immatriculation
  const getGenreByCode = (genreCode) => {
    setLoading(true)
    postGenreByCode(genreCode)
      .then((genre) => {
        if (genre?.status === 200 && genre?.data !== undefined) {
          setGenreImmat(genre.data.centreDefaut?.nom ?? '')
          setLoading(false)
        }
        if (genre?.status === 204) {
          setGenreImmat('')
          setLoading(false)
        }
      })
      .catch((e) => {
        console.error(e)
        setLoading(false)
      })
  }

  return (
    <>
      <div
        className='modal fade'
        id='exampleModalSearchV'
        aria-hidden='true'
        aria-labelledby='exampleModalToggleLabel2'
        tabIndex={-1}
        ref={modalRef}
      >
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='exampleModalToggleLabel2'>
                Recherche du véhicule
              </h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                ref={btnCloseRef}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              {/* Affichage du demande source */}
              {isFromClient && (
                // && (showDemandeSource || dataVehicle.length > 0)
                <div className='col-lg-12 col-sm-12 mb-5'>
                  <Select
                    className='react-select-styled react-select-solid react-select-lg'
                    classNamePrefix='react-select'
                    options={transformedSource}
                    fieldName='motif_refus'
                    value={
                      choicedDemandeSource?.value ||
                      transformedSource?.filter((ts) => ts.value === choicedDemandeSource)?.[0]
                    }
                    isLoading={sourceLoader}
                    onChange={(e) => setChoicedDemandeSource(e.value)}
                    placeholder='Sélectionner un canal'
                  />
                  {!choicedDemandeSource && (
                    <div className='d-flex gap-2 my-2 align-items-center'>
                      <i className='bi bi-info-square text-warning'></i>
                      <span className={'text-warning'}>
                        Veuillez choisir le canal de la demande
                      </span>
                    </div>
                  )}
                </div>
              )}
              {isImmatNotFound && (
                <div className='d-flex text-info mb-3 gap-2'>
                  <div className='te'>
                    Cette immatriculation n’a pas été trouvée dans la base SIV. Souhaitez-vous
                    effectuer une recherche par Marque et Modèle ?
                  </div>
                  <div className='te'>
                    <div className='d-flex gap-2'>
                      <i
                        className='bi bi-check fs-2x btn btn-primary p-1'
                        onClick={continueAction}
                      ></i>
                      <i
                        className='bi bi-x fs-2x btn btn-danger p-1'
                        onClick={() => setIsImmatNotFound(false)}
                      ></i>
                    </div>
                  </div>
                </div>
              )}
              <div className='row'>
                <div className='mb-5'>
                  <div className='row'>
                    <div className='col-md-12'>
                      <TextInput
                        fieldName={'immatriculation'}
                        inputPlaceholder={'Immatriculation'}
                        inputType={'text'}
                        inputClassName={
                          'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        }
                        formik={formik}
                      />
                    </div>
                  </div>
                  <div className='row mt-5'>
                    <div className='col-md-6'>
                      <TextInput
                        fieldName={'marque'}
                        inputPlaceholder={'Marque'}
                        inputType={'text'}
                        inputClassName={
                          'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        }
                        formik={formik}
                        required={formik.values.modele}
                        disabled={formik.values.immatriculation && disableMarqueModeleInput}
                      />
                    </div>
                    <div className='col-md-6'>
                      <TextInput
                        fieldName={'modele'}
                        inputPlaceholder={'Modèle'}
                        inputType={'text'}
                        inputClassName={
                          'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        }
                        formik={formik}
                        required={formik.values.marque}
                        disabled={formik.values.immatriculation && disableMarqueModeleInput}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {showDataImmat && (
                <div className='p-6 bg-light flex-column mb-5' style={{borderRadius: '8px'}}>
                  {loadingDataImmat ? (
                    <span
                      className='indicator-progress text-muted text-center'
                      style={{display: 'block'}}
                    >
                      Chargement en cours ...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    dataImmat && dataImmat?.sMessageErreur === '' ? (
                      <>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Immatriculation</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {dataImmat?.sImmatriculationSiv}
                          </span>
                        </div>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Marque</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {dataImmat?.smarque}
                          </span>
                        </div>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Modèle</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {dataImmat?.smodele}
                          </span>
                        </div>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Date 1ère circulation</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.sdatePme &&
                                  moment(dataImmat?.sdatePme).format('DD/MM/YYYY')}
                              </span>
                        </div>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>VIN</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {dataImmat?.sVin}
                          </span>
                        </div>
                        {/*debut afficher plus et afficher moins*/}
                        <div className='d-flex align-items-center mb-3 justify-content-center'>
                          <a
                            className='text-primary fw-bold fs-6 mx-3'
                            style={{cursor: 'pointer'}}
                            onClick={() => setDisplayInfoVehicule(!displayInfoVehicule)}
                          >
                            Afficher {displayInfoVehicule ? 'moins' : 'plus'}
                            <i
                              className={`text-primary bi bi-chevron-${
                                displayInfoVehicule ? 'up' : 'down'
                              } ms-2`}
                            ></i>
                          </a>
                        </div>
                        {/*fin afficher plus et afficher moins*/}
                        {displayInfoVehicule && (
                          <>
                            <hr className='flex-grow-1' style={{color: 'grey'}} />
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Centre</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {loading ? (
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                ) : (
                                  genreImmat
                                )}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Cylindrée</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.stecCylindree}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Énergie</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.stecEnergie}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Carrosserie</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.scarrosserie}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Puissance CV</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.spuissanceCv}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Puissance fiscale</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.spuissanceFiscale}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Code moteur</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.scodeMoteur}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Type boîte</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.stypeBoiteVitesse}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Couleur</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.scouleur}
                              </span>
                            </div>
                            <div className='row col-lg-12 pb-3'>
                              <span className='col-lg-6 text-muted'>Nombre de portes</span>
                              <span className='col-lg-6 d-flex justify-content-end'>
                                {dataImmat?.stecNbPortes}
                              </span>
                            </div>
                          </>
                        )}
                      </>
                    ) : (dataImmat?.sMessageErreur === 'No data for this vehicle' || dataImmat?.sMessageErreur === null) && (
                      <>
                        <span className='d-flex justify-content-center align-items-center text-muted'> Aucune donnée trouvée </span>
                      </>
                    )
                  )}
                </div>
              )}
              <div
                className='overflow-y-auto overflow-x-hidden'
                style={{
                  ...(dataVehicle.length > 0 && {
                    height: `${dynamicHeight}px`,
                  }),
                }}
              >
                {dataVehicle.length > 0 ? (
                  dataVehicle.map((v) => (
                    <div
                      key={v.id}
                      className='row px-5 pb-3 flex-column'
                      onClick={
                        isFromClient && !choicedDemandeSource
                          ? undefined
                          : () => {
                            getSiteVehicule(v?.id)
                              .then((response) => {
                                if (response?.status === 200 && response?.data !== undefined) {
                                  let vehiculeData = {
                                    ...v,
                                    immatriculationNonTrouvee: disableMarqueModeleInput ? null : immatRecherchee,
                                  }
                                  vehiculeData = {
                                    ...vehiculeData,
                                    site: response?.data?.site
                                  }
                                  handleNavigate(null, vehiculeData)
                                }
                              })
                          }
                      }
                      data-bs-dismiss={choicedDemandeSource ? 'modal' : ''}
                      data-tooltip-id='modal-tooltip'
                      data-tooltip-content={choicedDemandeSource ? 'Effectuer une demande' : ''}
                      data-tooltip-place='top'
                    >
                      <div
                        className={`p-3 bg-light border ${
                          choicedDemandeSource
                            ? 'bg-hover-light-info border-hover-info'
                            : 'bg-hover-light-danger border-hover-danger'
                        } rounded-1`}
                        style={{
                          cursor: choicedDemandeSource ? 'pointer' : 'not-allowed',
                          borderRadius: '23px',
                        }}
                      >
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Marque</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {v?.marque?.nom ?? 'N/C'}
                          </span>
                        </div>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Modèle</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {v?.nom ?? 'N/C'}
                          </span>
                        </div>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Phase</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {v?.phase ?? 'N/C'}
                          </span>
                        </div>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Début phase</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {v?.debutPhase ?? 'N/C'}
                          </span>
                        </div>
                        <div className='row col-lg-12 pb-3'>
                          <span className='col-lg-6 text-muted'>Fin phase</span>
                          <span className='col-lg-6 d-flex justify-content-end'>
                            {v?.finPhase ?? 'N/C'}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className={`${
                      message === 'Aucun résultat' &&
                      'text-center p-3 text-danger border border-danger bg-light-danger rounded-1'
                    }`}
                  >
                    {message}
                  </div>
                )}
              </div>
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light'
                data-bs-dismiss='modal'
                ref={btnCloseRef}
              >
                Fermer
              </button>
              {isFromAddClientContact && (
                <button
                  type='button'
                  className='btn btn-ligh-info'
                  data-bs-target='#choixContactModal'
                  data-bs-toggle='modal'
                  data-bs-dismiss='modal'
                >
                  Retour
                </button>
              )}
              {showBtnHT && (
                <button
                  type='button'
                  className='btn btn-warning'
                  disabled={!!(isFromClient && !choicedDemandeSource)}
                  data-bs-dismiss={loadingHtData ? 'modal' : ''}
                  onClick={() =>
                    handleNavigate(null, {
                      marque: {nom: formik.values.marque},
                      nom: formik.values.modele,
                      isHorsType: true,
                      id: formik.values.marque + ' - ' + formik.values.modele,
                    })
                  }
                >
                  Hors type
                  {loadingHtData && (
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  )}
                </button>
              )}
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleClick}
                disabled={isDisabled}
              >
                {!loadingCatdata && buttonLabel}

                {loadingCatdata && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {loadingLabel}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
        <Tooltip id='modal-tooltip' />
      </div>
    </>
  )
}

export default ResearchVehicleModal
